import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hideBackButton } from '~redux_related/ui/actionCreators';
import { iconBackBtn } from '~utils/svgIcons';
import { withRouter, Link } from 'react-router-dom';
import './style.scss';

function NavBackButton({ history, path = '/', isBackButtonVisible, hideBackButton }) {
    const onClick = React.useCallback(() => {
        if (isBackButtonVisible) hideBackButton();
        history.goBack();
    }, [isBackButtonVisible, hideBackButton, history]);

    if (history.length > 1) {
        return (
            <button type="button" className="nav-back-button" onClick={onClick}>
                {iconBackBtn('#C31B1C')}
            </button>
        );
    }
    return (
        <Link className="nav-back-button" to={path}>
            {iconBackBtn('#C31B1C')}
        </Link>
    );
}

NavBackButton.propTypes = {
    history: PropTypes.shape({
        goBack: PropTypes.func,
        length: PropTypes.number,
    }).isRequired,
    path: PropTypes.string,
};

const mapStateToProps = (state) => ({
    isBackButtonVisible: state.ui.isBackButtonVisible,
});

const mapDispatchToProps = (dispatch) => ({
    hideBackButton: () => dispatch(hideBackButton()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NavBackButton));



// WEBPACK FOOTER //
// ./src/components/nav-back-button/index.js